import React from 'react';

const ReceptionistHome = () => {
    return (
        <div className="p-4 min-h-screen bg-gray-50 flex flex-col items-center justify-center gap-4">
            <h1 className="text-6xl font-bold">Welcome to Nexus</h1>
            <p className="text-gray-500 font-thin text-2xl">Manage your receptionist tasks and activities</p>
        </div>
    );
};

export default ReceptionistHome;
// import React, { useState } from 'react';
// import {
//     Card,
//     CardBody,
//     Typography,
//     Chip,
//     Button,
//     Input,
//     Select,
//     Option,
//     IconButton,
//     Dialog,
//     DialogHeader,
//     DialogBody,
//     DialogFooter,
//     Textarea,
//     Tabs,
//     TabsHeader,
//     Tab,
//     TabsBody,
//     TabPanel,
// } from "@material-tailwind/react";
// import {
//     Calendar,
//     Clock,
//     Users,
//     Search,
//     Plus,
//     Eye,
//     Edit,
//     CheckCircle,
//     XCircle,
//     AlertCircle,
//     MessageSquare,
//     User,
//     Mail,
//     Phone,
//     Building,
//     Filter,
//     ChevronLeft,
//     ChevronRight,
// } from 'lucide-react';

// const ReceptionistHome = () => {
//     const [activeTab, setActiveTab] = useState('bookings');
//     const [selectedBooking, setSelectedBooking] = useState(null);
//     const [selectedTicket, setSelectedTicket] = useState(null);
//     const [bookingDialogOpen, setBookingDialogOpen] = useState(false);
//     const [ticketDialogOpen, setTicketDialogOpen] = useState(false);
//     const [createBookingOpen, setCreateBookingOpen] = useState(false);
//     const [createTicketOpen, setCreateTicketOpen] = useState(false);

//     // Mock data for meeting room bookings
//     const [bookings, setBookings] = useState([
//         {
//             id: 1,
//             title: "Client Presentation",
//             customer: { name: "Sarah Johnson", email: "sarah@example.com", phone: "+1234567890" },
//             meetingRoom: { number: "101", name: "Conference Room A", capacity: 12 },
//             startDate: "2024-01-15T09:00:00",
//             endDate: "2024-01-15T11:00:00",
//             slot: 120,
//             status: "confirmed",
//             description: "Quarterly business review with client"
//         },
//         {
//             id: 2,
//             title: "Team Standup",
//             customer: { name: "Mike Chen", email: "mike@example.com", phone: "+1234567891" },
//             meetingRoom: { number: "203", name: "Meeting Room B", capacity: 6 },
//             startDate: "2024-01-15T14:00:00",
//             endDate: "2024-01-15T15:00:00",
//             slot: 60,
//             status: "confirmed",
//             description: "Daily team sync"
//         },
//         {
//             id: 3,
//             title: "Board Meeting",
//             customer: { name: "Emma Williams", email: "emma@example.com", phone: "+1234567892" },
//             meetingRoom: { number: "101", name: "Conference Room A", capacity: 12 },
//             startDate: "2024-01-16T10:00:00",
//             endDate: "2024-01-16T12:30:00",
//             slot: 150,
//             status: "pending",
//             description: "Monthly board meeting"
//         },
//     ]);

//     // Mock data for support tickets
//     const [tickets, setTickets] = useState([
//         {
//             id: 1,
//             title: "WiFi Connection Issues",
//             customer: { name: "John Doe", email: "john@example.com", phone: "+1234567893" },
//             priority: "high",
//             status: "open",
//             category: "technical",
//             description: "Unable to connect to WiFi in office space",
//             createdAt: "2024-01-15T08:30:00",
//             updatedAt: "2024-01-15T08:30:00",
//         },
//         {
//             id: 2,
//             title: "Access Card Not Working",
//             customer: { name: "Alice Brown", email: "alice@example.com", phone: "+1234567894" },
//             priority: "medium",
//             status: "in_progress",
//             category: "access",
//             description: "Card reader not recognizing my access card",
//             createdAt: "2024-01-14T15:20:00",
//             updatedAt: "2024-01-15T09:00:00",
//         },
//         {
//             id: 3,
//             title: "Printer Maintenance Required",
//             customer: { name: "Robert Kim", email: "robert@example.com", phone: "+1234567895" },
//             priority: "low",
//             status: "resolved",
//             category: "maintenance",
//             description: "Printer on 2nd floor needs toner replacement",
//             createdAt: "2024-01-13T11:00:00",
//             updatedAt: "2024-01-15T10:30:00",
//         },
//     ]);

//     const getStatusColor = (status) => {
//         const colors = {
//             confirmed: "green",
//             pending: "amber",
//             cancelled: "red",
//             completed: "blue",
//             open: "red",
//             in_progress: "amber",
//             resolved: "green",
//             closed: "gray",
//         };
//         return colors[status] || "gray";
//     };

//     const getPriorityColor = (priority) => {
//         const colors = {
//             high: "red",
//             medium: "amber",
//             low: "green",
//         };
//         return colors[priority] || "gray";
//     };

//     const formatDateTime = (dateString) => {
//         const date = new Date(dateString);
//         return date.toLocaleString('en-US', {
//             month: 'short',
//             day: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit'
//         });
//     };

//     const formatDate = (dateString) => {
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-US', {
//             month: 'short',
//             day: 'numeric',
//             year: 'numeric'
//         });
//     };

//     const BookingCard = ({ booking }) => (
//         <Card className="mb-3 border border-gray-200 rounded-lg">
//             <CardBody className="p-4">
//                 <div className="flex justify-between items-start mb-3">
//                     <div className="flex-1">
//                         <Typography variant="h6" className="font-semibold mb-1">
//                             {booking.title}
//                         </Typography>
//                         <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
//                             <User size={14} />
//                             <span>{booking.customer.name}</span>
//                         </div>
//                     </div>
//                     <Chip
//                         value={booking.status}
//                         color={getStatusColor(booking.status)}
//                         className="rounded-lg capitalize"
//                     />
//                 </div>

//                 <div className="space-y-2 mb-3">
//                     <div className="flex items-center gap-2 text-sm text-gray-700">
//                         <Building size={14} />
//                         <span>Room {booking.meetingRoom.number} - {booking.meetingRoom.name}</span>
//                     </div>
//                     <div className="flex items-center gap-2 text-sm text-gray-700">
//                         <Calendar size={14} />
//                         <span>{formatDateTime(booking.startDate)}</span>
//                     </div>
//                     <div className="flex items-center gap-2 text-sm text-gray-700">
//                         <Clock size={14} />
//                         <span>{booking.slot} minutes</span>
//                     </div>
//                 </div>

//                 <div className="flex gap-2">
//                     <Button
//                         size="sm"
//                         variant="outlined"
//                         className="flex-1 rounded-lg border-gray-300"
//                         onClick={() => {
//                             setSelectedBooking(booking);
//                             setBookingDialogOpen(true);
//                         }}
//                     >
//                         <Eye size={16} className="mr-1" />
//                         View
//                     </Button>
//                     <Button
//                         size="sm"
//                         variant="outlined"
//                         className="flex-1 rounded-lg border-gray-300"
//                         onClick={() => {
//                             setSelectedBooking(booking);
//                             setCreateBookingOpen(true);
//                         }}
//                     >
//                         <Edit size={16} className="mr-1" />
//                         Edit
//                     </Button>
//                 </div>
//             </CardBody>
//         </Card>
//     );

//     const TicketCard = ({ ticket }) => (
//         <Card className="mb-3 border border-gray-200 rounded-lg">
//             <CardBody className="p-4">
//                 <div className="flex justify-between items-start mb-3">
//                     <div className="flex-1">
//                         <div className="flex items-center gap-2 mb-1">
//                             <Typography variant="h6" className="font-semibold">
//                                 {ticket.title}
//                             </Typography>
//                             <Chip
//                                 value={ticket.priority}
//                                 color={getPriorityColor(ticket.priority)}
//                                 size="sm"
//                                 className="rounded-lg capitalize"
//                             />
//                         </div>
//                         <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
//                             <User size={14} />
//                             <span>{ticket.customer.name}</span>
//                         </div>
//                     </div>
//                     <Chip
//                         value={ticket.status.replace('_', ' ')}
//                         color={getStatusColor(ticket.status)}
//                         className="rounded-lg capitalize"
//                     />
//                 </div>

//                 <div className="space-y-2 mb-3">
//                     <div className="flex items-center gap-2 text-sm text-gray-700">
//                         <MessageSquare size={14} />
//                         <span className="capitalize">{ticket.category}</span>
//                     </div>
//                     <div className="flex items-center gap-2 text-sm text-gray-700">
//                         <Calendar size={14} />
//                         <span>Created: {formatDate(ticket.createdAt)}</span>
//                     </div>
//                 </div>

//                 <div className="flex gap-2">
//                     <Button
//                         size="sm"
//                         variant="outlined"
//                         className="flex-1 rounded-lg border-gray-300"
//                         onClick={() => {
//                             setSelectedTicket(ticket);
//                             setTicketDialogOpen(true);
//                         }}
//                     >
//                         <Eye size={16} className="mr-1" />
//                         View
//                     </Button>
//                     <Button
//                         size="sm"
//                         variant="outlined"
//                         className="flex-1 rounded-lg border-gray-300"
//                         onClick={() => {
//                             setSelectedTicket(ticket);
//                             setCreateTicketOpen(true);
//                         }}
//                     >
//                         <Edit size={16} className="mr-1" />
//                         Update
//                     </Button>
//                 </div>
//             </CardBody>
//         </Card>
//     );

//     return (
//         <div className="min-h-screen bg-gray-50 p-6">
//             <div className="max-w-7xl mx-auto">
//                 {/* Header */}
//                 <div className="mb-6">
//                     <Typography variant="h3" className="font-bold mb-2">
//                         Receptionist Dashboard
//                     </Typography>
//                     <Typography variant="paragraph" className="text-gray-600">
//                         Manage meeting room bookings and support tickets
//                     </Typography>
//                 </div>

//                 {/* Stats Cards */}
//                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
//                     <Card className="border border-gray-200 rounded-lg">
//                         <CardBody className="p-4">
//                             <div className="flex items-center gap-3">
//                                 <div className="p-3 bg-blue-50 rounded-lg">
//                                     <Calendar className="text-blue-600" size={24} />
//                                 </div>
//                                 <div>
//                                     <Typography variant="small" className="text-gray-600">
//                                         Today's Bookings
//                                     </Typography>
//                                     <Typography variant="h4" className="font-bold">
//                                         8
//                                     </Typography>
//                                 </div>
//                             </div>
//                         </CardBody>
//                     </Card>

//                     <Card className="border border-gray-200 rounded-lg">
//                         <CardBody className="p-4">
//                             <div className="flex items-center gap-3">
//                                 <div className="p-3 bg-green-50 rounded-lg">
//                                     <CheckCircle className="text-green-600" size={24} />
//                                 </div>
//                                 <div>
//                                     <Typography variant="small" className="text-gray-600">
//                                         Confirmed
//                                     </Typography>
//                                     <Typography variant="h4" className="font-bold">
//                                         6
//                                     </Typography>
//                                 </div>
//                             </div>
//                         </CardBody>
//                     </Card>

//                     <Card className="border border-gray-200 rounded-lg">
//                         <CardBody className="p-4">
//                             <div className="flex items-center gap-3">
//                                 <div className="p-3 bg-amber-50 rounded-lg">
//                                     <AlertCircle className="text-amber-600" size={24} />
//                                 </div>
//                                 <div>
//                                     <Typography variant="small" className="text-gray-600">
//                                         Open Tickets
//                                     </Typography>
//                                     <Typography variant="h4" className="font-bold">
//                                         4
//                                     </Typography>
//                                 </div>
//                             </div>
//                         </CardBody>
//                     </Card>

//                     <Card className="border border-gray-200 rounded-lg">
//                         <CardBody className="p-4">
//                             <div className="flex items-center gap-3">
//                                 <div className="p-3 bg-purple-50 rounded-lg">
//                                     <Users className="text-purple-600" size={24} />
//                                 </div>
//                                 <div>
//                                     <Typography variant="small" className="text-gray-600">
//                                         Active Customers
//                                     </Typography>
//                                     <Typography variant="h4" className="font-bold">
//                                         24
//                                     </Typography>
//                                 </div>
//                             </div>
//                         </CardBody>
//                     </Card>
//                 </div>

//                 {/* Main Content */}
//                 <Card className="border border-gray-200 rounded-lg">
//                     <CardBody className="p-6">
//                         <Tabs value={activeTab}>
//                             <div className="flex justify-between items-center mb-6">
//                                 <TabsHeader className="bg-gray-100 w-auto rounded-lg">
//                                     <Tab
//                                         value="bookings"
//                                         onClick={() => setActiveTab('bookings')}
//                                         className="rounded-lg"
//                                     >
//                                         <Calendar size={18} className="mr-2 inline" />
//                                         Meeting Bookings
//                                     </Tab>
//                                     <Tab
//                                         value="tickets"
//                                         onClick={() => setActiveTab('tickets')}
//                                         className="rounded-lg"
//                                     >
//                                         <MessageSquare size={18} className="mr-2 inline" />
//                                         Support Tickets
//                                     </Tab>
//                                 </TabsHeader>

//                                 <Button
//                                     className="flex items-center gap-2 rounded-lg"
//                                     onClick={() => {
//                                         if (activeTab === 'bookings') {
//                                             setCreateBookingOpen(true);
//                                             setSelectedBooking(null);
//                                         } else {
//                                             setCreateTicketOpen(true);
//                                             setSelectedTicket(null);
//                                         }
//                                     }}
//                                 >
//                                     <Plus size={18} />
//                                     {activeTab === 'bookings' ? 'New Booking' : 'New Ticket'}
//                                 </Button>
//                             </div>

//                             {/* Search and Filter Bar */}
//                             <div className="flex gap-3 mb-6">
//                                 <div className="flex-1">
//                                     <Input
//                                         label="Search"
//                                         icon={<Search size={18} />}
//                                         className="rounded-lg"
//                                     />
//                                 </div>
//                                 <Button variant="outlined" className="rounded-lg border-gray-300">
//                                     <Filter size={18} className="mr-2" />
//                                     Filter
//                                 </Button>
//                             </div>

//                             <TabsBody>
//                                 <TabPanel value="bookings" className="p-0">
//                                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                                         {bookings.map((booking) => (
//                                             <BookingCard key={booking.id} booking={booking} />
//                                         ))}
//                                     </div>

//                                     {/* Pagination */}
//                                     <div className="flex justify-center items-center gap-4 mt-6">
//                                         <IconButton variant="outlined" className="rounded-lg border-gray-300">
//                                             <ChevronLeft size={18} />
//                                         </IconButton>
//                                         <Typography variant="small" className="text-gray-600">
//                                             Page 1 of 3
//                                         </Typography>
//                                         <IconButton variant="outlined" className="rounded-lg border-gray-300">
//                                             <ChevronRight size={18} />
//                                         </IconButton>
//                                     </div>
//                                 </TabPanel>

//                                 <TabPanel value="tickets" className="p-0">
//                                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//                                         {tickets.map((ticket) => (
//                                             <TicketCard key={ticket.id} ticket={ticket} />
//                                         ))}
//                                     </div>

//                                     {/* Pagination */}
//                                     <div className="flex justify-center items-center gap-4 mt-6">
//                                         <IconButton variant="outlined" className="rounded-lg border-gray-300">
//                                             <ChevronLeft size={18} />
//                                         </IconButton>
//                                         <Typography variant="small" className="text-gray-600">
//                                             Page 1 of 2
//                                         </Typography>
//                                         <IconButton variant="outlined" className="rounded-lg border-gray-300">
//                                             <ChevronRight size={18} />
//                                         </IconButton>
//                                     </div>
//                                 </TabPanel>
//                             </TabsBody>
//                         </Tabs>
//                     </CardBody>
//                 </Card>
//             </div>

//             {/* Booking Details Dialog */}
//             <Dialog
//                 open={bookingDialogOpen}
//                 handler={() => setBookingDialogOpen(false)}
//                 size="md"
//                 className="rounded-lg"
//             >
//                 {selectedBooking && (
//                     <>
//                         <DialogHeader className="border-b border-gray-200">
//                             <div className="flex justify-between items-start w-full">
//                                 <div>
//                                     <Typography variant="h5" className="font-bold">
//                                         {selectedBooking.title}
//                                     </Typography>
//                                     <Typography variant="small" className="text-gray-600 font-normal mt-1">
//                                         Booking ID: #{selectedBooking.id}
//                                     </Typography>
//                                 </div>
//                                 <Chip
//                                     value={selectedBooking.status}
//                                     color={getStatusColor(selectedBooking.status)}
//                                     className="rounded-lg capitalize"
//                                 />
//                             </div>
//                         </DialogHeader>
//                         <DialogBody className="space-y-4">
//                             <div>
//                                 <Typography variant="small" className="font-semibold mb-2 text-gray-700">
//                                     Customer Information
//                                 </Typography>
//                                 <div className="space-y-2 pl-2">
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <User size={16} className="text-gray-500" />
//                                         <span>{selectedBooking.customer.name}</span>
//                                     </div>
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <Mail size={16} className="text-gray-500" />
//                                         <span>{selectedBooking.customer.email}</span>
//                                     </div>
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <Phone size={16} className="text-gray-500" />
//                                         <span>{selectedBooking.customer.phone}</span>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div>
//                                 <Typography variant="small" className="font-semibold mb-2 text-gray-700">
//                                     Meeting Details
//                                 </Typography>
//                                 <div className="space-y-2 pl-2">
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <Building size={16} className="text-gray-500" />
//                                         <span>Room {selectedBooking.meetingRoom.number} - {selectedBooking.meetingRoom.name}</span>
//                                     </div>
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <Users size={16} className="text-gray-500" />
//                                         <span>Capacity: {selectedBooking.meetingRoom.capacity} people</span>
//                                     </div>
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <Calendar size={16} className="text-gray-500" />
//                                         <span>Start: {formatDateTime(selectedBooking.startDate)}</span>
//                                     </div>
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <Calendar size={16} className="text-gray-500" />
//                                         <span>End: {formatDateTime(selectedBooking.endDate)}</span>
//                                     </div>
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <Clock size={16} className="text-gray-500" />
//                                         <span>Duration: {selectedBooking.slot} minutes</span>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div>
//                                 <Typography variant="small" className="font-semibold mb-2 text-gray-700">
//                                     Description
//                                 </Typography>
//                                 <Typography variant="small" className="text-gray-600 pl-2">
//                                     {selectedBooking.description}
//                                 </Typography>
//                             </div>
//                         </DialogBody>
//                         <DialogFooter className="border-t border-gray-200 gap-2">
//                             <Button
//                                 variant="outlined"
//                                 onClick={() => setBookingDialogOpen(false)}
//                                 className="rounded-lg border-gray-300"
//                             >
//                                 Close
//                             </Button>
//                             <Button
//                                 onClick={() => {
//                                     setBookingDialogOpen(false);
//                                     setSelectedBooking(selectedBooking);
//                                     setCreateBookingOpen(true);
//                                 }}
//                                 className="rounded-lg"
//                             >
//                                 Edit Booking
//                             </Button>
//                         </DialogFooter>
//                     </>
//                 )}
//             </Dialog>

//             {/* Ticket Details Dialog */}
//             <Dialog
//                 open={ticketDialogOpen}
//                 handler={() => setTicketDialogOpen(false)}
//                 size="md"
//                 className="rounded-lg"
//             >
//                 {selectedTicket && (
//                     <>
//                         <DialogHeader className="border-b border-gray-200">
//                             <div className="flex justify-between items-start w-full">
//                                 <div>
//                                     <Typography variant="h5" className="font-bold">
//                                         {selectedTicket.title}
//                                     </Typography>
//                                     <Typography variant="small" className="text-gray-600 font-normal mt-1">
//                                         Ticket ID: #{selectedTicket.id}
//                                     </Typography>
//                                 </div>
//                                 <div className="flex gap-2">
//                                     <Chip
//                                         value={selectedTicket.priority}
//                                         color={getPriorityColor(selectedTicket.priority)}
//                                         size="sm"
//                                         className="rounded-lg capitalize"
//                                     />
//                                     <Chip
//                                         value={selectedTicket.status.replace('_', ' ')}
//                                         color={getStatusColor(selectedTicket.status)}
//                                         className="rounded-lg capitalize"
//                                     />
//                                 </div>
//                             </div>
//                         </DialogHeader>
//                         <DialogBody className="space-y-4">
//                             <div>
//                                 <Typography variant="small" className="font-semibold mb-2 text-gray-700">
//                                     Customer Information
//                                 </Typography>
//                                 <div className="space-y-2 pl-2">
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <User size={16} className="text-gray-500" />
//                                         <span>{selectedTicket.customer.name}</span>
//                                     </div>
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <Mail size={16} className="text-gray-500" />
//                                         <span>{selectedTicket.customer.email}</span>
//                                     </div>
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <Phone size={16} className="text-gray-500" />
//                                         <span>{selectedTicket.customer.phone}</span>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div>
//                                 <Typography variant="small" className="font-semibold mb-2 text-gray-700">
//                                     Ticket Details
//                                 </Typography>
//                                 <div className="space-y-2 pl-2">
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <MessageSquare size={16} className="text-gray-500" />
//                                         <span className="capitalize">Category: {selectedTicket.category}</span>
//                                     </div>
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <Calendar size={16} className="text-gray-500" />
//                                         <span>Created: {formatDate(selectedTicket.createdAt)}</span>
//                                     </div>
//                                     <div className="flex items-center gap-2 text-sm">
//                                         <Calendar size={16} className="text-gray-500" />
//                                         <span>Last Updated: {formatDate(selectedTicket.updatedAt)}</span>
//                                     </div>
//                                 </div>
//                             </div>

//                             <div>
//                                 <Typography variant="small" className="font-semibold mb-2 text-gray-700">
//                                     Description
//                                 </Typography>
//                                 <Typography variant="small" className="text-gray-600 pl-2">
//                                     {selectedTicket.description}
//                                 </Typography>
//                             </div>
//                         </DialogBody>
//                         <DialogFooter className="border-t border-gray-200 gap-2">
//                             <Button
//                                 variant="outlined"
//                                 onClick={() => setTicketDialogOpen(false)}
//                                 className="rounded-lg border-gray-300"
//                             >
//                                 Close
//                             </Button>
//                             <Button
//                                 onClick={() => {
//                                     setTicketDialogOpen(false);
//                                     setSelectedTicket(selectedTicket);
//                                     setCreateTicketOpen(true);
//                                 }}
//                                 className="rounded-lg"
//                             >
//                                 Update Ticket
//                             </Button>
//                         </DialogFooter>
//                     </>
//                 )}
//             </Dialog>

//             {/* Create/Edit Booking Dialog */}
//             <Dialog
//                 open={createBookingOpen}
//                 handler={() => setCreateBookingOpen(false)}
//                 size="lg"
//                 className="rounded-lg"
//             >
//                 <DialogHeader className="border-b border-gray-200">
//                     <Typography variant="h5" className="font-bold">
//                         {selectedBooking ? 'Edit Booking' : 'Create New Booking'}
//                     </Typography>
//                 </DialogHeader>
//                 <DialogBody className="max-h-[70vh] overflow-y-auto">
//                     <div className="space-y-4">
//                         <div>
//                             <Typography variant="small" className="font-semibold mb-2">
//                                 Booking Information
//                             </Typography>
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                 <Input label="Title" className="rounded-lg" defaultValue={selectedBooking?.title} />
//                                 <Input label="Customer Name" className="rounded-lg" defaultValue={selectedBooking?.customer.name} />
//                                 <Input label="Email" type="email" className="rounded-lg" defaultValue={selectedBooking?.customer.email} />
//                                 <Input label="Phone" type="tel" className="rounded-lg" defaultValue={selectedBooking?.customer.phone} />
//                             </div>
//                         </div>

//                         <div>
//                             <Typography variant="small" className="font-semibold mb-2">
//                                 Meeting Details
//                             </Typography>
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                 <Select label="Meeting Room" className="rounded-lg">
//                                     <Option>Room 101 - Conference Room A</Option>
//                                     <Option>Room 203 - Meeting Room B</Option>
//                                     <Option>Room 305 - Board Room</Option>
//                                 </Select>
//                                 <Input label="Start Date & Time" type="datetime-local" className="rounded-lg" />
//                                 <Select label="Duration" className="rounded-lg">
//                                     <Option>30 minutes</Option>
//                                     <Option>60 minutes</Option>
//                                     <Option>90 minutes</Option>
//                                     <Option>120 minutes</Option>
//                                 </Select>
//                                 <Select label="Status" className="rounded-lg">
//                                     <Option>Pending</Option>
//                                     <Option>Confirmed</Option>
//                                     <Option>Cancelled</Option>
//                                 </Select>
//                             </div>
//                         </div>

//                         <div>
//                             <Typography variant="small" className="font-semibold mb-2">
//                                 Description
//                             </Typography>
//                             <Textarea label="Meeting Description" className="rounded-lg" defaultValue={selectedBooking?.description} />
//                         </div>
//                     </div>
//                 </DialogBody>
//                 <DialogFooter className="border-t border-gray-200 gap-2">
//                     <Button
//                         variant="outlined"
//                         onClick={() => {
//                             setCreateBookingOpen(false);
//                             setSelectedBooking(null);
//                         }}
//                         className="rounded-lg border-gray-300"
//                     >
//                         Cancel
//                     </Button>
//                     <Button
//                         onClick={() => {
//                             setCreateBookingOpen(false);
//                             setSelectedBooking(null);
//                         }}
//                         className="rounded-lg"
//                     >
//                         {selectedBooking ? 'Update Booking' : 'Create Booking'}
//                     </Button>
//                 </DialogFooter>
//             </Dialog>

//             {/* Create/Edit Ticket Dialog */}
//             <Dialog
//                 open={createTicketOpen}
//                 handler={() => setCreateTicketOpen(false)}
//                 size="lg"
//                 className="rounded-lg"
//             >
//                 <DialogHeader className="border-b border-gray-200">
//                     <Typography variant="h5" className="font-bold">
//                         {selectedTicket ? 'Update Ticket' : 'Create New Ticket'}
//                     </Typography>
//                 </DialogHeader>
//                 <DialogBody className="max-h-[70vh] overflow-y-auto">
//                     <div className="space-y-4">
//                         <div>
//                             <Typography variant="small" className="font-semibold mb-2">
//                                 Customer Information
//                             </Typography>
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                 <Input label="Customer Name" className="rounded-lg" defaultValue={selectedTicket?.customer.name} />
//                                 <Input label="Email" type="email" className="rounded-lg" defaultValue={selectedTicket?.customer.email} />
//                                 <Input label="Phone" type="tel" className="rounded-lg" defaultValue={selectedTicket?.customer.phone} />
//                             </div>
//                         </div>

//                         <div>
//                             <Typography variant="small" className="font-semibold mb-2">
//                                 Ticket Details
//                             </Typography>
//                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                 <Input label="Title" className="rounded-lg" defaultValue={selectedTicket?.title} />
//                                 <Select label="Category" className="rounded-lg">
//                                     <Option>Technical</Option>
//                                     <Option>Access</Option>
//                                     <Option>Maintenance</Option>
//                                     <Option>Billing</Option>
//                                     <Option>Other</Option>
//                                 </Select>
//                                 <Select label="Priority" className="rounded-lg">
//                                     <Option>Low</Option>
//                                     <Option>Medium</Option>
//                                     <Option>High</Option>
//                                 </Select>
//                                 <Select label="Status" className="rounded-lg">
//                                     <Option>Open</Option>
//                                     <Option>In Progress</Option>
//                                     <Option>Resolved</Option>
//                                     <Option>Closed</Option>
//                                 </Select>
//                             </div>
//                         </div>

//                         <div>
//                             <Typography variant="small" className="font-semibold mb-2">
//                                 Description
//                             </Typography>
//                             <Textarea label="Ticket Description" className="rounded-lg" rows={6} defaultValue={selectedTicket?.description} />
//                         </div>
//                     </div>
//                 </DialogBody>
//                 <DialogFooter className="border-t border-gray-200 gap-2">
//                     <Button
//                         variant="outlined"
//                         onClick={() => {
//                             setCreateTicketOpen(false);
//                             setSelectedTicket(null);
//                         }}
//                         className="rounded-lg border-gray-300"
//                     >
//                         Cancel
//                     </Button>
//                     <Button
//                         onClick={() => {
//                             setCreateTicketOpen(false);
//                             setSelectedTicket(null);
//                         }}
//                         className="rounded-lg"
//                     >
//                         {selectedTicket ? 'Update Ticket' : 'Create Ticket'}
//                     </Button>
//                 </DialogFooter>
//             </Dialog>
//         </div>
//     );
// };

// export default ReceptionistHome;